// import {
//   RegistrationGuard,
//   RegistrationPage,
// } from "@shared/pages/registration";
import { AppLayout } from "@shared/modules/core/layout/app-layout";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";

import { GamesPage } from "./pages/Games";
import { HomePage } from "./pages/Home";

export const Routes = () => {
  return (
    <AppLayout>
      <Switch>
        <Route exact path="/" component={HomePage} />
        {<Route path="/games/:stringId" component={GamesPage} />}
        {/*<RegistrationGuard>*/}
        {/*  <Route path="/registration" component={RegistrationPage} />*/}
        {/*</RegistrationGuard>*/}
        <Redirect from="*" to="/" />
      </Switch>
    </AppLayout>
  );
};

Routes.displayName = "Routes";
